
<ul>
    <li>
        {{ 'organization-settings.crm.currentUserRules' | translate }}
        <span class="status" [class]="loadingState.currentUser"></span>
    </li>
    <li>
        <div>
            {{ 'organization-settings.crm.selectedUserRules' | translate }}
            <span class="status" [class]="loadingState.selectedUser"></span>
        </div>
        <div  class="grid-1col input-grid-gaps">
            <app-email-input
                id="email"
                autocorrect="off" spellcheck="false"
                [form]="form"
            ></app-email-input>
            @for (user of foundUsers() ; track user.id) {
                <div class="flex gap-small">
                    <p-radioButton name="user" [value]="user" [(ngModel)]="selectedUser" [inputId]="user.id" />
                    <label [for]="user.id" class="ml-2">
                        <div>{{ user.name }} {{ user.surname }} ({{ user.email }})</div>
                        <div>{{ user.id }}</div>
                    </label>
                </div>
            }
        </div>
    </li>
    <li>
        {{ 'organization-settings.crm.newCollectionCategory' | translate }} {{ orgName }}
        <span class="status" [class]="loadingState.collectionType"></span>
    </li>
    <li>
        {{ 'organization-settings.crm.newCollection' | translate }} {{ orgName }}
        <span class="status" [class]="loadingState.collection"></span>
    </li>
</ul>


